/** @jsx jsx */
import { jsx } from 'theme-ui'

function Navbar() {
  return (<div></div>)
}

export default Navbar